import { render } from "./ContactoView.vue?vue&type=template&id=3fc4b8ce&scoped=true"
import script from "./ContactoView.vue?vue&type=script&lang=js"
export * from "./ContactoView.vue?vue&type=script&lang=js"

import "./ContactoView.vue?vue&type=style&index=0&id=3fc4b8ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc4b8ce"]])

export default __exports__